import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { ServicesService } from '../../../services/services.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';


export interface ServicesReply {
    CreatedDate: Date;
    OwnerImg: string;
    OwnerName: string;
    Description: string;
}


@Component({
  selector: 'app-services-sdr-details',
  templateUrl: './services-sdr-details.component.html',
  styleUrls: ['./services-sdr-details.component.scss']
})
export class ServicesSdrDetailsComponent implements OnInit {

    constructor(private route: ActivatedRoute,
        private router: Router, private servicesService: ServicesService,
        private authentication: AuthenticationService,
        private common: CommonService) { }

    id: string = "0";

    errorMessage: string = "";
    isError: boolean = false;

    sdrObj: any = {

        Contact__r: {
            Id: "",
            Name: "",
            attributes: {
                type: "",
                url: ""
            }
        },
        Client__r: {
            Id: "",
            Name: "",
            attributes: {
                type: "",
                url: ""
            }
        },
        SDR_Responsible__r: {
            Id: "",
            Name: "",
            attributes: {
                type: "",
                url: ""
            }
        },
        Id: "",
        Name: "",
        Client__c: "",
        CreatedDate: "",
        LastModifiedDate: "",
        Contact__c: "",
        Origin__c: "",
        Type__c: "",
        ContainAttachment__c: false,
        ContainSubTasks__c: false,
        SDR_Responsible__c: "",
        Status__c: "",
        Consumed_Man_Days__c: 0.0,
        Deducted_Man_Days__c: 0.0,
        Is_it_Free__c: false,
        Work_Order_Description__c: "",
        Customer_Approved__c: false,
        Final_Customer_Approval__c: false,
        SDR_Type__c: "",
        Start_Date__c: "",
        End_Date__c: "",
        Customer_Comment__c: "",
        Customer_Commnet_final__c: "",
        Initial_Confirmed_Date__c: "",
        Finial_Approed_Date_Time__c: "",
        Category__c: ""
    };

    files: any = [];

    emailSuffix: any = "";

    sdrFollowers: any[] = [];

    ccDeleteLoading: boolean = false;

    ccAddLoading: boolean = false;

    newFollowerEmail: any = "";

    activityHistory: any = {
        Description: ""
    };

    

    btnSendDisabled: boolean = false;
    btnSend: string = "Send";

    SDRAttachments: any[] = [];

    pagecode: string = "serv-detail";
    accessdenied: boolean = false;
    module: string = "services";

    sdrFinalApproval = {
        SFID: "",
        Comment: "",
        isApproved: false
    };
    finalApprovalObj = {
        Comment: "",
        btnDisabled: false
    };

    submitSDRAttachments(sdrId: any) {


        var files = this.files;
        var attachmentsObj = {
            ParentId: sdrId,
            attachments: []
        };
        for (var i = 0; i < files.length; i++) {

            var file = files[i];
            var isLastIndex = false;
            if (i == files.length - 1)
                isLastIndex = true;
            this.getFile(file, attachmentsObj, isLastIndex);
        }

    }

    sendActivityHistory() {
        if (this.activityHistory.Description != "") {
            this.btnSendDisabled = true;
            this.btnSend = "Sending";

            this.activityHistory.SdrId = this.id;
            this.activityHistory.Subject = "";
            this.activityHistory.Status = "Completed";
            this.activityHistory.Type = "Web";
            this.activityHistory.Priority = "Normal";
            this.activityHistory.WhoId = this.authentication.userData.sfContactId;
            this.activityHistory.ActivityDate = new Date();
            if (this.files.length > 0)
                this.submitSDRAttachments(this.id);

            let _self = this;
            debugger;
            this.servicesService.addSDRActivityHistory(this.activityHistory).subscribe(
                (res: any) => {
                    debugger;
                    if (res.success) {
                        if (res) {
                            _self.activityHistory.Description = "";
                        }
                        _self.SDRActivityLog.push({
                            CreatedDate: new Date(res.data.createdDate),
                            Description: res.data.description,
                            OwnerImg: res.data.ownerImg,
                            OwnerName: res.data.ownerName
                        });
                        //_self.SDRActivityLog.push(res['activityObject']);
                    }
                    _self.btnSendDisabled = false;
                    _self.btnSend = "Send";
                },
                (err: any) => {
                    _self.btnSendDisabled = false;
                    _self.btnSend = "Send";
                }
            );

        }
        else {
            this.common.ShowMessage('error', 'your reply is mandatory', '')
        }
    }

    removeFile(fileIndex: any) {
        this.files.splice(fileIndex, 1);
    }

    filesSelect(selectedFiles: any): void {

        for (var i = 0; i < selectedFiles.target.files.length; i++) {
            this.files.push(selectedFiles.target.files[i]);
        }
    }
    getFile(file: any, attachmentsObj: any, isLastIndex: any) {

        var reader = new FileReader();
        let _self = this;
        reader.onload = function (readerEvt) {

            var binaryString = readerEvt['target']!['result']!.toString().split(',')[1];
            //var binaryString = "";
            var contentType = file.type;
            if (file.name.toLowerCase().indexOf(".zip") !== -1 && file.type === "")
                contentType = "application/x-zip-compressed";
            attachmentsObj.attachments.push({
                ContentType: contentType,
                Name: file.name,
                Body: binaryString
            });

            if (isLastIndex) {
                _self.files = [];
                _self.servicesService.addAttachment(attachmentsObj).subscribe(
                    (res: any) => {
                        _self.getSDRAttachments(_self.id);
                    },
                    (err: any) => {
                        console.error("getFile addAttachment", err);
                    }
                );
            }
        };
        reader.readAsDataURL(file);
    }

    sendFinalApproval(isApproved: any) {
        this.finalApprovalObj.btnDisabled = true;
        this.sdrFinalApproval = {
            SFID: this.id,
            Comment: this.sdrObj.Customer_Commnet_final__c,
            isApproved: isApproved
        };
        this.servicesService.sendFinalApproval(this.sdrFinalApproval).subscribe(
            (response: any) => {
                this.sdrObj = response;
                this.finalApprovalObj.btnDisabled = false;
            },
            (err: any) => {
                this.finalApprovalObj.btnDisabled = false;
            });
    }



    sdrApproval = {
        SFID: "",
        Comment: "",
        isApproved: false
    };
    initialApprovalObj = {
        Comment: "",
        btnDisabled: false
    };
    sendInitialApproval(isApproved: any) {
        this.initialApprovalObj.btnDisabled = true;
        this.sdrApproval = {
            SFID: this.id,
            Comment: this.sdrObj.Customer_Comment__c,
            isApproved: isApproved
        };
        this.servicesService.sendInitialApproval(this.sdrApproval).subscribe(
            (response: any) => {
                this.sdrObj = response;
                this.initialApprovalObj.btnDisabled = false;
            },
            (err: any) => {
                this.initialApprovalObj.btnDisabled = false;
            });
    }

    ngOnInit(): void {

        let map: any = this.route.paramMap;
        this.id = map.destination._value.id;
        this.emailSuffix = "@" + this.authentication._authentication.userName.split("@")[1];

        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {

                        var pageURL = this.router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

                        this.getSDRById();
                        this.getSDRActivityHistory();

                        window.scroll(0, 0);

                    }
                    else {
                        this.accessdenied = true;
                    }
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );


        });


    }

    getSDRById() {

        this.servicesService.getSDRById(this.id).subscribe(
            (res: any) => {
                if (res.success) {
                    if (res.data) {
                        //

                        // requested by Georges on 22/9/2022 by email - SDP Terminology Change
                        if (res.data.Status__c.toLowerCase() === 'Awaiting For Initial Approval'.toLowerCase())
                            res.data.Status__c = "Confirmation to Start the Work";
                        else if (res.data.Status__c.toLowerCase() === 'Awaiting for final approval'.toLowerCase())
                            res.data.Status__c = "Completion Confirmation";
                        //

                        this.sdrObj = res.data;
                        //

                        if (res.data.ContainSubTasks__c) {
                            this.getSDRSubTasks(this.id);
                        }
                        if (res.data.ContainAttachment__c)
                            this.getSDRAttachments(this.id);
                    }
                    else {
                        console.error("getSDRById()", "data is null");
                    }
                }
                else {
                    console.error("getSDRById()", res.error_message);
                }
            },
            (err: any) => {
                console.error("getSDRById()", err);
            }

        );


    }
    SDRActivityLog: Array<ServicesReply> = [];


    getSDRActivityHistory() {
        debugger;
        this.servicesService.getSDRActivityHistory(this.id).subscribe(
            (res: any) => {
                debugger;
                for (var i = 0; i < res.data.length; i++) {
                    this.SDRActivityLog.push({
                        CreatedDate: new Date(res.data[i].createdDate),
                        Description: res.data[i].description,
                        OwnerImg: res.data[i].ownerImg,
                        OwnerName: res.data[i].ownerName
                    });
                }
                //this.SDRActivityLog = res;
                console.log("activityLog", this.SDRActivityLog);
            },
            (err: any) => {
                console.error("getSDRActivityHistory", err);
            }
        );
    }
    getSDRAttachments(SDRId: any) {
        this.servicesService.getSDRAttachments(SDRId).subscribe(
            (response: any) => {

                for (var i = 0; i < response.length; i++) {
                    response[i].href = "data:" + response[i].ContentType + ";base64," + response[i].Body;
                }
                this.SDRAttachments = response;
            },
            (err: any) => {
                console.error("getSDRAttachments()", err);
            });
    }

    SDRSubTasks: any[] = [];
    isAllSubTasksCompleted: boolean = true;

    getSDRSubTasks(SDRId: any) {
        console.log("getSDRSubTasks()", SDRId);
        this.servicesService.getSDRSubTasks(SDRId).subscribe(
            (response: any) => {
                console.log("getSDRSubTasks() response", response);
                if (response.success) {
                    if (response.data) {

                        this.isAllSubTasksCompleted = true;
                        for (var i = 0; i < response.data.length; i++) {
                            if (response.data[i].Status__c != 'Cancelled') {
                                this.SDRSubTasks.push(response.data[i])
                                if (response.data[i].Status__c != 'Completed') {
                                    this.isAllSubTasksCompleted = false;
                                }
                            }
                        }
                        console.log("this.SDRSubTasks", this.SDRSubTasks);
                    }
                    else
                        console.error("getSDRSubTasks()", "data is null");

                }
                else
                    console.error("getSDRSubTasks()", response.error_message);



            },
            (err: any) => {
                console.error("getSDRSubTasks()", err);
            });
    }

    downloadAttachment(href: any, name: any) {
        var link = document.createElement('a');
        link.href = href;
        var fileName = name;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}

